import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { getRefreshToken } from "../actions/Dashboard.action";
import AuthWrapper from "./AuthWrapper/AuthWrapper";

const PrivateOutlet = ({ auth, loading, getRefreshToken }) => {
  const navigate = useNavigate();
  useEffect(() => {
    const authFunc = async () => {
      if (auth === null) {
        let check = await getRefreshToken();

        if (check === true) {
          return <Outlet />;
        } else {
          navigate("/");
        }
      }
    };
    authFunc();
  }, [auth, getRefreshToken]);
  return auth === null ? (
    <AuthWrapper auth={auth}>
      <Outlet></Outlet>
    </AuthWrapper>
  ) : auth === true ? (
    <AuthWrapper auth={auth}>
      <Outlet></Outlet>
    </AuthWrapper>
  ) : null;
};

const mapStateToProps = (state) => ({
  auth: state.auth.isAuthenticated,
  loading: state.auth.loading,
});

export default connect(mapStateToProps, { getRefreshToken })(PrivateOutlet);
